import { ExamDistributionNavigationTabs } from '@exam-center/exam-distribution';
import { Flex, PageHeader } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function ExamDistributionGroupedLayout() {
  return (
    <Flex
      sx={(theme) => ({
        bgcolor: theme.palette.grey[50],
        flexDirection: 'column',
        height: '100dvh',
        width: '100%',
      })}
    >
      <PageHeader title='มอบหมายชุดข้อสอบ' tabs={<ExamDistributionNavigationTabs />} />
      <Outlet />
    </Flex>
  );
}
